/* eslint-disable import/prefer-default-export */
import styled from "styled-components";
import { RadioGroup } from "@kitbird/core";

export const UserInformationText = styled.div`
    display: flex;
    flex-direction: column;
`;

export const UserInformation = styled.div`
    position: relative;
    display: flex;
    gap: 24px;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin-top: 1.5rem;

    .avatar {
        width: 56px;
        height: 56px;
    }

    .background-corner {
        position: absolute;
        right: 0;
        bottom: 0;
    }
`;

export const RadioGroupWrapper = styled(RadioGroup)`
    margin-top: 1.5rem;

    &>div{
        justify-content: space-between;
    }
`;

export const RadioWrapper = styled.div<{ $disabled?: boolean }>`
    display: flex;
    align-items: center;
    width: 100%;
    cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
    
    label {
        cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")} !important;
        width: 100%;
    }
    
    input[type="radio"] {
        cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")} !important;
    }
`;

export const UserPlacement = styled.div`
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid #DEDEDE;
    border-radius: 8px;
    max-height: 300px;
    overflow-y: auto;

    .user-placement-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: "100%";

        .user-placement-header-text {
            display: flex;
            flex-direction: column;
            gap: 4px;
        }
    }

    .user-placement-body {
        .user-placement-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 1.2rem;
        }
        
        padding: 1rem 0;
        border-bottom: 1px solid #dedede;

        &:last-of-type,
        &:only-of-type {
            border: none;
            padding-bottom: 0;
        }
    }
`;

export const ReplacementUserSection = styled.div`
    margin-top: 1.5rem;
    padding: 1rem;
    border: 1px solid #DEDEDE;
    border-radius: 8px;
`;

export const Footer = styled.div`
    margin-top: 48px;
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
`;
